import { render, staticRenderFns } from "./ProdutosHistorico.vue?vue&type=template&id=2f71e654&scoped=true&"
import script from "./ProdutosHistorico.vue?vue&type=script&lang=js&"
export * from "./ProdutosHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71e654",
  null
  
)

export default component.exports